export const StopIcon = (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 74">
    <path
        d="M0 0 C1.12855637 0.71277244 2.23681107 1.45969793 3.3125 2.25 C4.199375 2.8275 5.08625 3.405 6 4 C11.46077863 9.31319002 14.40300093 15.16017294 14.60449219 22.79760742 C14.67130625 29.76933625 14.56930014 35.45602202 10.3125 41.25 C9.735 42.136875 9.1575 43.02375 8.5625 43.9375 C3.24930998 49.39827863 -2.59767294 52.34050093 -10.23510742 52.54199219 C-17.20683625 52.60880625 -22.89352202 52.50680014 -28.6875 48.25 C-30.0178125 47.38375 -30.0178125 47.38375 -31.375 46.5 C-36.83577863 41.18680998 -39.77800093 35.33982706 -39.97949219 27.70239258 C-40.04630625 20.73066375 -39.94430014 15.04397798 -35.6875 9.25 C-35.11 8.363125 -34.5325 7.47625 -33.9375 6.5625 C-25.62494489 -1.98095942 -11.06158618 -5.42443168 0 0 Z"
        fill="var(--YW_Body_StopResponding_Icon_Color)"
        transform="translate(49.6875,12.75)"
    />
    <path
        d="M0 0 C6.27 0 12.54 0 19 0 C19 5.94 19 11.88 19 18 C12.73 18 6.46 18 0 18 C0 12.06 0 6.12 0 0 Z"
        fill="#F5F4F4"
        transform="translate(27,29)"
    />
</svg>
);
